import JumToTopButton from './JumpToTopButton.vue';

export default JumToTopButton;
